import React from "react";
import { Outlet, useLoaderData, useParams } from "react-router";
import ErrorPage from "./Error";

const AuthWrapper = () => {
  const { success } = useLoaderData();

  if (!success) return <ErrorPage status={404} />;
  return <Outlet />;
};

export default AuthWrapper;

export const loader = async ({ params }) => {
  const { userType } = params;
  if (userType !== "seller" && userType !== "buyer" && userType !== "trader") {
    return { success: false };
  } else {
    return { success: true };
  }
};
